import { CssDevice, getFeatureEnabled, cdnService, FeatureEnabledV2 } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { BREAKPOINT_DEVICE_UPDATED, Feature } from '@gig/magic-messages';
import { StaticPageMixin } from '../../mixins/static-page.mixin.js';
import '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import '../../mixins/competitions.mixin.js';

/**
 * Component displaying static page header only.
 * Displays background, image, title, description and content (optionally)
 */
var StaticPageHeaderComponent = /** @class */ (function (_super) {
    __extends(StaticPageHeaderComponent, _super);
    function StaticPageHeaderComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.personalisedOffers = [];
        _this.personalizedOfferfilter = 'personalised offer';
        _this.showMobilePersonalisedOffers = false;
        _this.breakpointSubscription = null;
        _this.IsMobileOrPhablet = false;
        _this.enhancedCoversEnabled = false;
        return _this;
    }
    StaticPageHeaderComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.breakpointSubscription = window.eventBus.subscribe(BREAKPOINT_DEVICE_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                    var device, isMobileOrPhablet;
                    return __generator(this, function (_a) {
                        device = event.payload;
                        isMobileOrPhablet = device === CssDevice.MOBILE || device === CssDevice.PHABLET;
                        this.showMobilePersonalisedOffers = isMobileOrPhablet;
                        this.IsMobileOrPhablet = isMobileOrPhablet;
                        return [2 /*return*/];
                    });
                }); }, { replay: true });
                return [2 /*return*/];
            });
        });
    };
    StaticPageHeaderComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.breakpointSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    StaticPageHeaderComponent.prototype.getPersonalisedOffers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var arePersonalisedOffersEnabled, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.PERSONALISED_OFFERS)];
                    case 1:
                        arePersonalisedOffersEnabled = _b.sent();
                        if (!arePersonalisedOffersEnabled) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, magic.methods.promotions.filter(this.personalizedOfferfilter, this.magicConfig.language, this.magicConfig.mobile)];
                    case 2:
                        _a.personalisedOffers = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StaticPageHeaderComponent.prototype, "isLeaderboardsPage", {
        get: function () {
            return this.slug === 'bonus_leaderboards';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "isFaqPage", {
        get: function () {
            return this.slug === 'customersupport_faq';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "shouldReplaceBgWithImage", {
        get: function () {
            if (typeof this.page === 'string') {
                return false;
            }
            return (this.useImageForMobileBg &&
                this.IsMobileOrPhablet &&
                this.page.image);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "image", {
        get: function () {
            if (!this.page || typeof this.page === 'string' || !this.page.image) {
                return '';
            }
            return cdnService.getPageImageUrl(this.page.image);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "oneThird", {
        get: function () {
            return this.variant === 'one-third';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "oneFourth", {
        get: function () {
            return this.variant === 'one-fourth';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "shouldApplyEnhancedSize", {
        get: function () {
            return !this.oneThird && !this.oneFourth && this.enhancedCoversEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "topNav", {
        get: function () {
            return this.variant === 'top-nav';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "narrow", {
        get: function () {
            return this.variant === 'narrow';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageHeaderComponent.prototype, "isHomePage", {
        get: function () {
            if (!this.page || typeof this.page === 'string' || !this.page.name) {
                return '';
            }
            return this.page.name === 'homepage';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "hideTitle", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "hideImage", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "hideDescription", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "showContent", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "marketingBanner", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageHeaderComponent.prototype, "variant", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "transparent", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "useImageForMobileBg", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.ENHANCED_COVERS_ON_STATIC_PAGES }),
        __metadata("design:type", Boolean)
    ], StaticPageHeaderComponent.prototype, "enhancedCoversEnabled", void 0);
    __decorate([
        Watch('magicConfig.language', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], StaticPageHeaderComponent.prototype, "getPersonalisedOffers", null);
    StaticPageHeaderComponent = __decorate([
        Component({
            name: 'static-page-header',
        })
    ], StaticPageHeaderComponent);
    return StaticPageHeaderComponent;
}(Mixins(StaticPageMixin)));

export default StaticPageHeaderComponent;
